import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeIconComponent } from '../ce-icon/ce-icon.component';

@Component({
  selector: 'app-icon-container',
  templateUrl: './icon-container.component.html',
  styleUrls: ['./icon-container.component.scss'],
  imports: [CommonModule, CeIconComponent],
})
export class IconContainerComponent {
  @Output() onAction: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  Type: 'icon' | 'emoji' = 'icon';

  @Input()
  Size: 'large' | 'medium' | 'small' = 'large';

  @Input()
  IconType: any = 'user';

  @Input()
  background_color: string = '';

  onClick() {
    this.onAction.emit();
  }
}
